import { render, staticRenderFns } from "./NodeRemoveBtn.vue?vue&type=template&id=537b1ce3&"
import script from "./NodeRemoveBtn.vue?vue&type=script&lang=js&"
export * from "./NodeRemoveBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports